import SubLabel from "components/Atoms/Sublabel";
import { CompanyPreview } from "components/PreviewPanel/Company/CompanyPreviewPanel";
import { RemovableLabel, RemovableProps } from "components/Removables/Removable";
import React from "react";

interface Props extends RemovableProps<server.dto.CompanySmall> {
  hideEditButton?: boolean;
}

const RemovableCompany = (props: Props) => {

  return <RemovableLabel {...props}>
    <div>
      <CompanyPreview
        companyId={props.value.companyId}
        trigger={<a>{props.value.name}</a>}
      />
      <SubLabel>{props.value.cityCountry}</SubLabel>
    </div>

  </RemovableLabel>;
};

export default RemovableCompany;